import { Link } from "gatsby";
import React from "react";
import { motion, spring } from "framer-motion";
import { useGlobalContext } from "../../utils/context";
import { CgClose } from "react-icons/cg";

export default function WebinarSignUp() {
  const { showWebinar, setShowWebinar } = useGlobalContext();
  return (
    <>
      <motion.div
        initial={{ x: 0, y: 300 }}
        animate={{ x: 0, y: 150 }}
        transition={{
          duration: 2,
          delay: 4,
          type: spring,
          bounce: 0.4,
        }}
        className="fixed bottom-0 left-0 z-50 m-auto inset-x-0"
      >
        <div
          className={`w-screen mx-auto text-white z-40 ease-in-out duration-500 px-6  ${
            showWebinar ? "translate-y-0 " : "-translate-y-40 delay-1500"
          }`}
        >
          {" "}
          <div className="bg-novaDarkGrey container w-fit mx-auto pl-8 pr-4 py-3 rounded-full flex flex-wrap justify-center">
            <div className="flex">
              <p className="w-full text-xl font-medium text-white inline pr-5 text-center py-2 -mt-2 md:mt-0">
                <span className="hidden md:inline-block">Marketing in 2026 - </span> Watch our latest webinar <span className="hidden lg:inline-block">👉</span>
              </p>
            </div>
            <div className="flex">
              <Link
                to="/webinars/marketing-in-2026-download"
                className="mr-4 relative inline-flex items-center justify-center px-6 py-2 text-lg sm:text-xl overflow-hidden font-bold text-white bg-novaPink rounded-full group "
              >
                <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-novaPink2 rounded-full group-hover:w-80 group-hover:h-80"></span>
                <span className="absolute inset-0 w-full h-full rounded-full"></span>
                <span className="relative">Marketing in 2026 Webinar</span>
              </Link>
            </div>
            <div className="flex">
              <button
                type="button"
                onClick={() => setShowWebinar(!showWebinar)}
                className="items-center block hover:text-black hover:border-black"
                aria-label="Show Webinar"
              >
                <span className="bg-novaPink block w-8 h-8 pt-0 rounded-full border-2 border-novaDarkGrey -mr-20 sm:mr-0 -mt-20 sm:-mt-5">
                  {!showWebinar ? (
                    <CgClose className="inline-block text-xl text-novaBlue" />
                  ) : (
                    <CgClose className="inline-block text-xl text-novaBlue" />
                  )}
                </span>
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
}
